///include /assets/js/app/p/card-capture.js
///include /assets/js/app/p/promise-proxy.js

class CardCaptureSquare extends CardCaptureDriver {
    static get type() {
        return "square"
    }
    constructor() {
        super()
        this.promiseProxy = new PromiseProxy()
    }
    get canCapture() {
        return !!(
            CheckoutInfo.inst.info &&
            CheckoutInfo.inst.info.card &&
            CheckoutInfo.inst.info.card.type == CardCaptureSquare.type && //
            CheckoutInfo.inst.info.card.captureKey
        )
    }
    /**
     *
     * @param {?string} return_url
     * @param {boolean} [from_vue]
     */
    init(return_url = null, from_vue = true) {
        /** @type {HTMLFormElement} */
        //@ts-ignore
        const pf = document.querySelector("#payment-form")
        if(pf && !pf.getAttribute("action")) {
            const action = safeLocalUrl(return_url, null)
            if(action) {
                pf.action = action
            } else {
                throw new Error(`Invalid return URL: ${return_url}`)
            }
        }
        this.notFromVue = !from_vue
        if(!from_vue) {
            /** @type {HTMLButtonElement} */
            //@ts-ignore
            const submit = document.querySelector(
                "#modal-add-card button.btn-primary, #card-details button.btn-primary"
            )
            submit.addEventListener(
                "click",
                () => this.submitForm()
            )
        }
    }
    /**
     * @param {HTMLFormElement} pf
     */
    async initForm(pf) {

        if (window.location.pathname == "/checkout") {
            return window.location.replace("/account/billing-details");
        }

        if(!pf.getAttribute("action")) {
            throw new Error(`No form action, please see errors`)
        }
        this.mountPoint = `#${pf.id}`
        const ci = CheckoutInfo.inst
        const info = await ci.preloadSingle("info")
        await Site.require_once("/assets/js/lib/p/template-loader.js")
        await Site.require_once("/assets/js/shared/square-form.js")

        const capture_key = info.card.captureKey
        const s = await SquareForm.init(
            capture_key,
            this.mountPoint,
            info.card.captureExtraInfo,
            (nonce, verification_result, name) =>
                this.promiseProxy.resolve([nonce, verification_result, name]),
            e => this.promiseProxy.reject(e)
        )
        this.square = s
    }
    async submitForm() {
        /**
         * @type {GET.CustomerInformation.serviceOwnerContact.me.output}
         */
        // Part of submitting a card, not of loading the page.
        /** @optional /a/serviceOwnerContact/me */
        const contact = await $.ajax(`/a/serviceOwnerContact/me`)
        const [nonce, verification_result, name] = await this.promiseProxy.promise(
            () => this.square.requestCardNonce()
        )
        /** @type {HTMLFormElement} */
        //@ts-ignore
        const pf = document.querySelector("#payment-form")
        await $.ajax({
            method: "post",
            url: pf.action,
            data: {
                token: {
                    card: {
                        token: nonce,
                        verificationToken: verification_result,
                    },
                    email_address: contact.email,
                    name: name,
                },
            }
        })
        if(this.notFromVue) {
            location.href = "/account/billing-details"
        }
    }
}
CardCaptureDriver.add(CardCaptureSquare)
